export default "__VITE_ASSET__Be$SBx4U__"